import './setupAxios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ConfirmProvider } from './common/ConfirmDialog';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import ConfirmEmailPage from './auth/ConfirmEmailPage';
import ForgotPasswordPage from './auth/ForgotPasswordPage';
import ResetPasswordPage from './auth/ResetPasswordPage';
import Matches from './Matchs/Matches';
import ViewGroups from './Groups/ViewGroups';
import ViewBracket from './Bracket/ViewBracket';
import Viewer from './Viewer';
import Tournaments from './Tournament/Tournaments';
import MyFavoritesPage from './Tournament/MyFavoritesPage';
import TournamentActions from './Tournament/TournamentActions';
import AppShell from './layout/AppShell';
import LandingPage from './landing/LandingPage';
import CreateTournamentPage from './Tournament/CreateTournamentPage';
import TournamentSetup from './Tournament/TournamentSetup';
import TournamentGamesPage from './Tournament/TournamentGamesPage';
import TournamentGamesAdminPage from './Tournament/TournamentGamesAdminPage';
import TournamentCollaboratorsPage from './Tournament/TournamentCollaboratorsPage';
import TournamentGroupOrderPage from './Tournament/TournamentGroupOrderPage';
import TournamentPremiumMediaPage from './Tournament/TournamentPremiumMediaPage';
import TournamentAnalyticsPage from './Tournament/TournamentAnalyticsPage';
import MesasHubPage from './Mesa/MesasHubPage';
import MesaPartidoPage from './Mesa/MesaPartidoPage';
import MesaMultiplePage from './Mesa/MesaMultiplePage';
import MesaBracketPartidoPage from './Mesa/MesaBracketPartidoPage';
import DocumentationPage from './docs/DocumentationPage';
import RequireAuth from './auth/RequireAuth';
import RootLayout from './layout/RootLayout';

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/confirm-email', element: <ConfirmEmailPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
      {
        element: <AppShell />,
        children: [
          { path: '/', element: <LandingPage /> },
          { path: '/documentacion', element: <DocumentationPage /> },
          { path: '/viewgroups/:tournamentId', element: <ViewGroups /> },
          { path: '/matches/:tournamentId', element: <Matches /> },
          { path: '/viewbracket/:tournamentId', element: <ViewBracket /> },
          { path: '/tournamentactions/:tournamentId', element: <TournamentActions /> },
          { path: '/tournamentactions/:tournamentId/juegos', element: <TournamentGamesPage /> },
          {
            element: <RequireAuth />,
            children: [
              { path: '/tournamentactions/:tournamentId/juegos/gestionar', element: <TournamentGamesAdminPage /> },
              { path: '/mis-torneos', element: <Tournaments /> },
              { path: '/mis-favoritos', element: <MyFavoritesPage /> },
              { path: '/crear-torneo', element: <CreateTournamentPage /> },
              { path: '/viewer/:tournamentId', element: <Viewer /> },
              { path: '/tournamentactions/:tournamentId/setup', element: <TournamentSetup /> },
              { path: '/tournamentactions/:tournamentId/colaboradores', element: <TournamentCollaboratorsPage /> },
              { path: '/tournamentactions/:tournamentId/orden-grupos', element: <TournamentGroupOrderPage /> },
              { path: '/tournamentactions/:tournamentId/premium-media', element: <TournamentPremiumMediaPage /> },
              { path: '/tournamentactions/:tournamentId/audiencia', element: <TournamentAnalyticsPage /> },
              { path: '/tournamentactions/:tournamentId/mesa', element: <MesasHubPage /> },
              { path: '/tournamentactions/:tournamentId/mesa/multiple', element: <MesaMultiplePage /> },
              { path: '/tournamentactions/:tournamentId/mesa/final/:matchId', element: <MesaBracketPartidoPage /> },
              { path: '/tournamentactions/:tournamentId/mesa/:matchId', element: <MesaPartidoPage /> },
            ],
          },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ConfirmProvider>
        <RouterProvider router={router} />
      </ConfirmProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
